import { render, staticRenderFns } from "./relatedformmatter.vue?vue&type=template&id=0e60a474&scoped=true&"
import script from "./relatedformmatter.vue?vue&type=script&lang=js&"
export * from "./relatedformmatter.vue?vue&type=script&lang=js&"
import style0 from "./relatedformmatter.vue?vue&type=style&index=0&id=0e60a474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e60a474",
  null
  
)

export default component.exports